import { useState } from 'react'
import Typography from '../../../../components/common/Typography'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { InlineContainer } from '../../../../components/common/Containers'
import { RouterLink } from '../../../../components/common/Buttons'
import { IconButton } from '@material-ui/core'
import ConfirmDialog from '../../../../components/generics/Confirm/Dialog'
import useBooleanHandlers from '../../../../hooks/useBooleanHandlers'
import { useTrans } from '../../../../services/i18n'
import Switch from '../../../../components/common/Inputs/Switch'
import usePopover from '../../../../hooks/usePopover'

import connect from '../../connect'
import { useNavigate } from 'react-router-dom'
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import { useAlertContext } from '../../../../contexts/AlertContext'

const Item = ({ form, deleteForm, changeStatusForm }) => {
  const [openRemove, onOpenRemove, onCloseRemove] = useBooleanHandlers()
  const [pendingRemove, setPendingRemove] = useState(false)
  const [anchorEl, onOpenPopover, onClosePopover] = usePopover()
  const navigate = useNavigate()
  const { successAlert, errorAlert, infoAlert } = useAlertContext()

  const { trans } = useTrans()
  const onDeleteForm = () => {
    setPendingRemove(true)
    deleteForm({
      type: 'adjust',
      id: form.id,
    })
      .then(() => {
        setPendingRemove(false)
        onCloseRemove()
        successAlert('Adjust form deleted!')
      })
      .catch(error => {
        errorAlert(error.message)
      })
  }

  const changeStatus = () => {
    changeStatusForm({
      type: 'adjust',
      id: form.id,
      active: form.active ? false : true,
    })
      .then(res => {
        successAlert('State changed!')
      })
      .catch(error => {
        errorAlert(error.message)
      })
  }

  const openLink = () => {
    window.open(form.url, '_blank')
  }

  return (
    <>
      <TableRow>
        <TableCell align="left">
          <InlineContainer spacing={1}>
            <Typography
              weight="500"
              to={`/form/${form.adjustFormId}`}
              variant="h6"
              component={RouterLink}
              noWrap
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '40rem',
              }}
            >
              {form.name}
            </Typography>
          </InlineContainer>
        </TableCell>

        <TableCell align="left">
          <Typography variant="inherit" fontFamily="lexend">
            <Switch
              checked={form.active}
              onChange={() => changeStatus()}
              inputProps={{ 'aria-label': 'module' }}
              color="primary"
            />
          </Typography>
        </TableCell>
        <TableCell align="right">
          <IconButton onClick={() => onOpenRemove()}>
            <DeleteOutlineOutlinedIcon />
          </IconButton>
          <IconButton onClick={() => openLink()}>
            <OpenInNewIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <ConfirmDialog
        open={openRemove}
        onClose={onCloseRemove}
        onConfirm={onDeleteForm}
        pending={pendingRemove}
        title={trans('remove-form')}
        text={`Are you sure you want to remove this form`}
      >
        <Typography color="hint">{form.name}</Typography>
      </ConfirmDialog>
    </>
  )
}

export default connect(Item)
